import React, { useContext, useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import { PrimaryButton } from "../../atoms/Buttons";
import PageHero from "../../molecules/PageHero";
import { H3, P } from "../../atoms/Texts";
import { DarkFormField } from "../../atoms/Inputs";
import { OrganizationCard } from "../../atoms/Cards";
import { DashedCard } from "../../atoms/Cards/card.dotted";
import { demoContext } from "../../../shared/store/contexts";

import Joyride from "react-joyride";
import { useWalkthrough } from "../../../shared/hooks/useWalkthrough";

const JoinOrganizationPage = () => {
  const steps = [
    {
      target: ".search-org",
      content: "Use this field to search for organisations.",
    },
    {
      target: ".add-org-button",
      content: "Click here to add a new organisation.",
    },
    {
      target: ".enter-org",
      content: "Get the demo started with an existing organisation.",
    },
  ];

  const { joyrideProps } = useWalkthrough({
    steps,
    walkthroughKey: "join_organisation",
    pageSpecific: true, // Each page tracks separately
  });

  const { organization } = useContext(demoContext);

  const [organizations, setOrganizations] = useState([organization]);

  const {
    formState: { errors },
  } = useForm();

  return (
    <>
      <Joyride
        key={joyrideProps.run ? "walkthrough-active" : "walkthrough-inactive"}
        {...joyrideProps}
      />

      <main>
        <PageHero
          title="My organizations"
          description="Manage your organizations and join new organizations."
        />

        <section className="container pb-10">
          <>
            <P color="" fontSize="14px" className="text-center my-5">
              Search for organizations you want to claim.
            </P>
            <div className="mt-6 md:flex justify-center items-center">
              <form className="md:w-2/5">
                <div className="flex flex-wrap lg:flex-no-wrap">
                  <div className="w-full flex-grow">
                    <DarkFormField
                      type="search"
                      id="query"
                      name="query"
                      className="py-1 flex w-full"
                      placeholder="Search organization"
                      data_testid="query-input"
                    />
                    {errors.query && (
                      <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                        {errors.query}
                      </P>
                    )}
                  </div>
                  <div className="md:ml-4 search-org">
                    <PrimaryButton>Search</PrimaryButton>
                  </div>
                </div>
              </form>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
              {organizations?.map((organization) => (
                <Link
                  key={organization?.id}
                  to={`/dashboard/organization/${organization?.id}`}
                >
                  <div className="enter-org" />
                  <OrganizationCard
                    location={organization?.locations?.address}
                    description={organization?.description}
                    title={organization?.name}
                    orgId={organization?.id}
                  />
                </Link>
              ))}
              <div className="add-org-button">
                <Link to={`/dashboard/create-organization`}>
                  <DashedCard title="Add New Organization" />
                </Link>
              </div>
            </div>
          </>
        </section>
      </main>
    </>
  );
};

export default JoinOrganizationPage;
